<script setup lang="ts">
import { usePageStore } from '@voix/store/pageStore'
import type { ConditionInterface, ConditionsInterface, ElementInterface } from '@voix/types'
import { computed, defineProps } from 'vue'
import type { ComputedRef } from 'vue'

const props = defineProps<{
  element: ElementInterface
}>()

const pageStore = usePageStore()

const elementConditions: ComputedRef<ConditionsInterface> = computed(() => props.element.conditions_settings)

function addCondition() {
  const newCondition = {
    key: '',
    operator: 'greater_than_or_equals',
    value: 1,
  }

  pageStore.addConditionToElement(props.element.id, newCondition)
}

function removeCondition(condition: ConditionInterface) {
  pageStore.removeConditionFromElement(props.element.id, condition)
}
</script>

<template>
  <div class="text-sm border-b border-gray-200 mb-4 pb-2">
    <div class="font-medium voix-admin-text">
      Manage Slice XP Conditions
    </div>
    <div>
      This allows you to set conditions on if the slice should be shown or not.
    </div>
    <div class="flex justify-end">
      <button class="py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="addCondition">
        Add Condition
      </button>
    </div>
  </div>

  <div class="space-y-1">
    <div class="space-y-2">
      <div class="flex justify-center">
        <select v-model="elementConditions.type" class="border border-gray-200 rounded-sm p-2 text-sm w-full ">
          <option value="and">
            All conditions must be true
          </option>
          <option value="or">
            At least one condition must be true
          </option>
        </select>
      </div>

      <div v-if="elementConditions.conditions" v-for="condition, j in elementConditions.conditions" :key="`${n}${j}`" class="flex justify-between">
        <div class=" grid grid-cols-8 gap-1 text-sm">
          <input v-model="condition.key" type="text" class="col-span-2 border border-gray-200 rounded-sm p-2 text-sm" placeholder="Key">
          <select v-model="condition.operator" class="col-span-4 border border-gray-200 rounded-sm p-2 text-sm">
            <option value="equals">
              Equals
            </option>
            <option value="not_equals">
              Does not equal
            </option>
            <option value="contains">
              Contains
            </option>
            <option value="not_contains">
              Does not contain
            </option>
            <option value="greater_than">
              Greater Than
            </option>
            <option value="greater_than_or_equals">
              Greater Than or Equals
            </option>
            <option value="less_than">
              Less Than
            </option>
            <option value="less_than_or_equals">
              Less Than or Equals
            </option>
            <option value="is_empty">
              Is Not Set
            </option>
            <option value="is_not_empty">
              Is Set
            </option>
          </select>
          <input v-model="condition.value" type="text" class="col-span-2  border border-gray-200 rounded-sm p-2 text-sm" placeholder="Value">
        </div>

        <button class="ml-2 py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="removeCondition(condition)">
          Delete
        </button>
      </div>
    </div>
  </div>
</template>
